import { ENTERPRISE_ADLE_MODULE_VALUES } from "../../utils/constants";
import { enterpriseIntakeDefaultValues } from "./enterpriseIntakeDefaultValues";
import {
  ENTERPRISE_INTAKE_ORGANIZATION_TYPE_BRAND,
  isEnterpriseIntakeAgency,
} from "./enterpriseIntakeFormValues";
import { isModuleSelected } from "./enterpriseIntakeModuleUtils";

export { enterpriseIntakeDefaultValues };

export const getEnterpriseIntakeSectionVisibility = ({
  selectedAdleModules,
  organizationType,
  mediaManagementAddon,
  readOnly,
  formValues,
}) => {
  const selectedModules = selectedAdleModules ?? [];
  const isAgency = isEnterpriseIntakeAgency(organizationType);
  const hasCreativeAssets = isModuleSelected({
    selectedModules,
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.CREATIVE_ASSETS,
  });
  const hasPaidMediaLaunch = isModuleSelected({
    selectedModules,
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_LAUNCH,
  });
  const hasOptimizations = isModuleSelected({
    selectedModules,
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_OPTIMIZATION,
  });

  const showCreativeAssets =
    hasCreativeAssets ||
    (readOnly && Boolean(formValues?.module1MonthlyNewImagesCount));
  const showCampaigns =
    hasPaidMediaLaunch ||
    hasOptimizations ||
    (readOnly && Boolean(formValues?.module2MonthlyCampaignsCount));
  const showOptimizationFrequency =
    hasOptimizations ||
    (readOnly && Boolean(formValues?.optimizationFrequency));
  const showWhiteLabel =
    isAgency || (readOnly && Boolean(formValues?.whiteLabelRequirement));
  const showMediaManagementAddon =
    !isAgency ||
    organizationType === ENTERPRISE_INTAKE_ORGANIZATION_TYPE_BRAND ||
    (readOnly && Boolean(formValues?.mediaManagementAddon));
  const showMediaSpend =
    (!isAgency && mediaManagementAddon === "yes") ||
    (readOnly && Boolean(formValues?.monthlyMediaSpendUsd));

  return {
    isAgency,
    showCreativeAssets,
    showCampaigns,
    showOptimizationFrequency,
    showWhiteLabel,
    showMediaManagementAddon,
    showMediaSpend,
  };
};
